// Canadian Football physical constants.
//
// Shares `YARD_M` with the American Football module but the pitch is wider
// (65 yd vs 53 yd) and the hash pattern sits 24 yd from each sideline.

import { YARD_M } from '../american-football/constants'

/** Pitch width in yards (sideline-to-sideline). */
export const PITCH_WIDTH_YD = 65

/** Pitch width in metres. */
export const PITCH_WIDTH_M = PITCH_WIDTH_YD * YARD_M

/** CFL hashes sit 24 yards from each sideline. */
export const HASH_INSET_YD = 24

/** CFL hash inset expressed in metres. */
export const HASH_INSET_M = HASH_INSET_YD * YARD_M

export { YARD_M }
